/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { TransactionDto } from "./TransactionDto";
import {
    TransactionDtoFromJSON,
    TransactionDtoFromJSONTyped,
    TransactionDtoToJSON,
} from "./TransactionDto";

/**
 *
 * @export
 * @interface ConnectorAndActiveTransactionInfo
 */
export interface ConnectorAndActiveTransactionInfo {
    /**
     *
     * @type {number}
     * @memberof ConnectorAndActiveTransactionInfo
     */
    connectorIndex?: number;
    /**
     * Connector status mapped to an enum
     * @type {string}
     * @memberof ConnectorAndActiveTransactionInfo
     */
    connectorState?: ConnectorAndActiveTransactionInfoConnectorStateEnum;
    /**
     * Raw connector status as reported from the device. Eg Available,SuspendedEV,Unknown
     * @type {string}
     * @memberof ConnectorAndActiveTransactionInfo
     */
    connectorStatus?: string;
    /**
     * Time the connector changed to this status
     * @type {Date}
     * @memberof ConnectorAndActiveTransactionInfo
     */
    statusTimestamp?: Date;
    /**
     * The in-progress active energy consumption (null if no transaction, 0 if still waiting for first MeterValue)
     * @type {number}
     * @memberof ConnectorAndActiveTransactionInfo
     */
    consumptionWh?: number;
    /**
     * The in-progress active power for all phases (null if no transaction, 0 if still waiting for first MeterValue)
     * @type {number}
     * @memberof ConnectorAndActiveTransactionInfo
     */
    powerRmsW?: number;
    /**
     * The in-progress total cost (if a price is defined)
     * @type {number}
     * @memberof ConnectorAndActiveTransactionInfo
     */
    totalCost?: number;
    /**
     * The in-progress state of charge (DC chargers only)
     * @type {number}
     * @memberof ConnectorAndActiveTransactionInfo
     */
    stateOfCharge?: number;
    /**
     *
     * @type {TransactionDto}
     * @memberof ConnectorAndActiveTransactionInfo
     */
    transaction?: TransactionDto;
}

/**
 * @export
 */
export const ConnectorAndActiveTransactionInfoConnectorStateEnum = {
    Unknown: "Unknown",
    Available: "Available",
    Preparing: "Preparing",
    Charging: "Charging",
    Discharging: "Discharging",
    Suspended: "Suspended",
    Finishing: "Finishing",
    FullyCharged: "FullyCharged",
    Reserved: "Reserved",
    Unavailable: "Unavailable",
    Faulted: "Faulted",
} as const;
export type ConnectorAndActiveTransactionInfoConnectorStateEnum =
    (typeof ConnectorAndActiveTransactionInfoConnectorStateEnum)[keyof typeof ConnectorAndActiveTransactionInfoConnectorStateEnum];

/**
 * Check if a given object implements the ConnectorAndActiveTransactionInfo interface.
 */
export function instanceOfConnectorAndActiveTransactionInfo(
    value: object,
): value is ConnectorAndActiveTransactionInfo {
    return true;
}

export function ConnectorAndActiveTransactionInfoFromJSON(
    json: any,
): ConnectorAndActiveTransactionInfo {
    return ConnectorAndActiveTransactionInfoFromJSONTyped(json, false);
}

export function ConnectorAndActiveTransactionInfoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ConnectorAndActiveTransactionInfo {
    if (json == null) {
        return json;
    }
    return {
        connectorIndex:
            json["connectorIndex"] == null ? undefined : json["connectorIndex"],
        connectorState:
            json["connectorState"] == null ? undefined : json["connectorState"],
        connectorStatus:
            json["connectorStatus"] == null
                ? undefined
                : json["connectorStatus"],
        statusTimestamp:
            json["statusTimestamp"] == null
                ? undefined
                : new Date(json["statusTimestamp"]),
        consumptionWh:
            json["consumptionWh"] == null ? undefined : json["consumptionWh"],
        powerRmsW: json["powerRmsW"] == null ? undefined : json["powerRmsW"],
        totalCost: json["totalCost"] == null ? undefined : json["totalCost"],
        stateOfCharge:
            json["stateOfCharge"] == null ? undefined : json["stateOfCharge"],
        transaction:
            json["transaction"] == null
                ? undefined
                : TransactionDtoFromJSON(json["transaction"]),
    };
}

export function ConnectorAndActiveTransactionInfoToJSON(
    value?: ConnectorAndActiveTransactionInfo | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        connectorIndex: value["connectorIndex"],
        connectorState: value["connectorState"],
        connectorStatus: value["connectorStatus"],
        statusTimestamp:
            value["statusTimestamp"] == null
                ? undefined
                : value["statusTimestamp"].toISOString(),
        consumptionWh: value["consumptionWh"],
        powerRmsW: value["powerRmsW"],
        totalCost: value["totalCost"],
        stateOfCharge: value["stateOfCharge"],
        transaction: TransactionDtoToJSON(value["transaction"]),
    };
}
